import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setActiveTab } from '../../redux/slices/header-slice.js';
import useNewScs from '../../hooks/useNewScs.js';
import NewScCardsList from '../../components/new-sc-vetting-cards/NewScCardsList.jsx';
import SubLinks from '../../components/header/SubLinks.jsx';
import { scLinks } from '../../config/standard-links.js';
import LoadingSpinner from '../../components/common/LoadingSpinner.jsx';
import ErrorMessage from '../../components/common/ErrorMessage.jsx';

const Fishbowl = () => {
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const { loading, error, newScs, searchNewScs, totalPages } = useNewScs();

    useEffect(() => {
        dispatch(setActiveTab('Fishbowl'));
        return () => dispatch(setActiveTab(null));
    }, []);

    useEffect(() => {
        const getFishbowlSCs = async () => {
            const limit = 40;
            const type = 'paused'; // IMPORTANT: this type should filter by paused cards
            await searchNewScs('', type, '', currentPage, limit);
        };

        getFishbowlSCs();
    }, [currentPage]);
    return (
        <div className="notes-container">
            <SubLinks links={scLinks} />
            <br />
            <br />
            <br />
            <h2 style={{ padding: '20px' }}>Fishbowl (Paused SCs)</h2>
            {/* Show loading spinner */}
            {loading && <LoadingSpinner />}

            {/* Show error if any */}
            {error && <ErrorMessage message={error.message} />}
            {newScs.length > 0 && (
                <NewScCardsList
                    newScs={newScs}
                    totalPages={totalPages}
                    setCurrentPage={setCurrentPage}
                    customContainerStyles={{ marginTop: '40px' }}
                />
            )}
            {/* Show message if no data and not loading */}
            {!loading && newScs.length === 0 && (
                <p style={{ padding: '20px' }}>
                    No paused SCs in the Fishbowl.
                </p>
            )}
        </div>
    );
};

export default Fishbowl;
